import React from 'react';
import { Button, Stack } from '@customink/pigment-react';
import { EcmsPortal } from '~/adapters/services/accounts/tax-exemptions-ECMS-old/types';
import { LinkInBlank } from '~/components/Link/LinkInBlank';
import * as Sentry from '@sentry/react';

interface TaxExemptionsCertificatesButtonsProps {
    portalData: EcmsPortal | null | undefined;
}

// We want to infer (from the welcomeUrl) the link leading to the first step of the form (called "select states")
const transformToSelectStatesURL = (portalWelcomeUrl: string) => {
    if (!portalWelcomeUrl.match('welcome')) {
        // this code has the knowledge of TTR, an external system. If the returned link no longer contains 'welcome', that knowledge is invalid -> then do not display the inferred link
        Sentry.captureMessage(
            'Error in parsing external TTR url from tax-exemption api. Missing "welcome" substring.',
            { level: 'error' },
        );
        return null;
    }
    return portalWelcomeUrl.replace('welcome', 'selectstates');
};

export const TaxExemptionsPortalLinks: React.FC<TaxExemptionsCertificatesButtonsProps> = ({ portalData }) => {
    if (!portalData) {
        return null;
    }
    const portalWelcomeUrl = portalData.portalUrl;
    const portalSelectStatesUrl = transformToSelectStatesURL(portalData.portalUrl);

    return (
        <Stack mb={2} gap={1} direction="row" justifyContent="flex-end" flexWrap="wrap">
            <Button href={portalWelcomeUrl} LinkComponent={LinkInBlank} variant="secondary">
                Review Certificates
            </Button>
            {portalSelectStatesUrl && (
                <Button href={portalSelectStatesUrl} LinkComponent={LinkInBlank} variant="secondary">
                    Add A New Certificate
                </Button>
            )}
        </Stack>
    );
};
